import { Component, inject, OnInit } from '@angular/core';
import { LanguageService, SwarmLoginService } from 'src/app/services';
import { OLD_SITE, OLD_SITE_VIDEO } from 'src/environments/environment.local';
import { FormatPricePipe } from '../../../../../../pipe/format-price.pipe';
import { TranslateModule } from '@ngx-translate/core';
import { PictureComponent } from '../../../../../../shared/components/picture/picture.component';
import { NgClass, AsyncPipe, TitleCasePipe } from '@angular/common';
import { LazyImageDirective } from '../../../../../../directive/lazyImage.directive';
import { AppearDirective } from '../../../../../../directive/appear.directive';
import { AnimateOnChangeDirective } from '../../../../../../directive/animate-on-change.directive';
import { Store } from '@ngrx/store';
import * as comparePlansHelpers from 'app/modules/dashboard/helpers/compare-plans.helpers';
import { map, Observable, firstValueFrom } from 'rxjs';
import { SubscriptionPlan } from 'app/models/subscrition-plan.model';
import { selectSubscritionsProducts } from 'app/store/products/products.selectors';
import { CartActions } from 'app/modules/dashboard/store/cart/cart.actions';
import { Router } from '@angular/router';
import { KinoSubscription } from 'app/modules/dashboard/models/kino-subscription.model';
import { selectActiveSubscription } from 'app/modules/dashboard/store/subscriptions/subscriptions.selectors';
import {
  selectMeCurrency,
  selectProfileData,
  selectSettings,
} from 'app/store/me/me.selectors';
import { ModalService } from 'app/services/modal.service';
import { configureConnectionModal } from 'app/helpers/modal-helpers';
import { Settings } from 'app/modules/dashboard/models/settings.model';
import { MultiSwitchComponent } from '@kinomap-dev/ng-ui-lib';
import { SubscriptionsProductsActions } from 'app/store/products/products.actions';
import { CurrencyType } from 'app/services/gift-cards-plans.service';

@Component({
  selector: 'app-step-six',
  templateUrl: './step6.component.html',
  styleUrls: ['./step6.component.scss'],
  standalone: true,
  imports: [
    AppearDirective,
    LazyImageDirective,
    NgClass,
    PictureComponent,
    TranslateModule,
    FormatPricePipe,
    AsyncPipe,
    TitleCasePipe,
    AnimateOnChangeDirective,
    MultiSwitchComponent,
  ],
})
export class Step6Component implements OnInit {
  private languageService: LanguageService = inject(LanguageService);
  private store: Store = inject(Store);
  private router: Router = inject(Router);
  private modal: ModalService = inject(ModalService);
  private loginService: SwarmLoginService = inject(SwarmLoginService);

  lifetimeEndDate: Date = new Date('2025-12-31');
  lifetimeDaysLeft: number = Math.ceil(
    (this.lifetimeEndDate.getTime() - new Date().getTime()) /
      (1000 * 60 * 60 * 24)
  );

  currency$: Observable<CurrencyType> =
    this.languageService.currency.asObservable();
  onlyProducts: boolean = false;

  clientIsLog$: Observable<boolean> = this.store
    .select(selectProfileData)
    .pipe(map((profile) => !!profile));
  anim = false;
  anim2 = false;
  dashboard = OLD_SITE;
  videoSite = OLD_SITE_VIDEO;
  rewardLink: string;
  activeSubscription$: Observable<KinoSubscription> = this.store.select(
    selectActiveSubscription
  );
  isPlanAvailable = (
    plan: SubscriptionPlan,
    activeSubscription: KinoSubscription
  ) => comparePlansHelpers.isPlanAvailable(plan, activeSubscription);
  products$: Observable<SubscriptionPlan[]> = this.store
    .select(selectSubscritionsProducts)
    .pipe(
      map((products: SubscriptionPlan[]) => {
        return products.filter(
          (product: SubscriptionPlan) => product.name !== 'family'
        );
      })
    );
  settings$: Observable<Settings> = this.store.select(selectSettings);

  updateCurrency(currency: CurrencyType): void {
    this.languageService.currency.next(currency);
    this.store.dispatch(
      SubscriptionsProductsActions.getSubscriptionsProducts({ currency })
    );
  }

  ngOnInit(): void {
    this.languageService.langEmitter.subscribe((el: string) => {
      this.setLink(el);
      this.store
        .select(selectMeCurrency)
        .subscribe((currency: CurrencyType) => {
          this.updateCurrency(currency);
        });
    });
    this.setLink(this.languageService.get());
  }

  async navToUpload(): Promise<void> {
    const clientIsLog: boolean = await firstValueFrom(this.clientIsLog$);
    if (clientIsLog) {
      this.router.navigate(['browse', 'upload']);
      return;
    }
    this.modal.display('connection-modal');
    configureConnectionModal(this.modal, this.loginService);
  }

  navitageToCart(subscription: SubscriptionPlan) {
    this.store.dispatch(CartActions.addProduct({ productId: subscription.id }));
    this.router.navigate(['dashboard', 'subscriptions', 'order'], {
      queryParams: { subscription: subscription.name },
    });
  }

  // To remove
  private setLink(el: string) {
    this.rewardLink =
      el === 'fr-FR'
        ? 'https://info.kinomap.com/fr-reward-program'
        : 'https://info.kinomap.com/en-reward-program';
  }
}
